const moveUp = () => {
  $('.js-move-up').each(function() {
    const $this = $(this);
    let moveOffset = $this.data('offset')
    const windowHeight = $(window).height();
    const offsetTop = $this.offset().top;
    const offsetBottom = offsetTop + $this.height();

    $(document).on('load scroll', function() {
      const scrollOffset = $(window).scrollTop() + $(window).height();

      if ($(window).width() < 767) {
        moveOffset = $this.data('offset-mobile');
      } else {
        moveOffset = $this.data('offset');
      }

      if (userHasScrolledToElem($this)) {
        const delta = scrollOffset - offsetTop; // pixels scrolled from the begining of the element
        const percent = (delta*100/($this.height() + $(window).height())).toFixed(2); // the scrolled part of the element in percents
        const moveBy = moveOffset*percent/100;

        $this.css('transform', `translateY(-${moveBy}px`);
      }
    })
  })

  /*
   * Check if user has scrolled to elem
   *
   * @param  {DOM elem} elem
   * @return {Boolean}
   */
  function userHasScrolledToElem($element) {
    const scrollPositionTop = $(window).scrollTop();
    const scrollPositionBottom = scrollPositionTop + $(window).height();
    const elementPositionTop = $element.offset().top;
    const elementPositionBottom = $element.offset().top + $element.height();
    const elementTopIsReached = scrollPositionBottom >= elementPositionTop;
    const elementBottomIsReached = scrollPositionTop <= elementPositionBottom;

    return elementTopIsReached && elementBottomIsReached;
  }
}

moveUp()
